import "./Cororation.css";
export default function Corporation() {
  return (
  
  <div>
  <div className="corporation"></div>;
  <div className='corporation-one'></div>
  <div className= 'corporation-two'></div>
  <div className= 'corporation-three'></div>
  
  
  <span style={{position:'absolute',margin:'-6rem 4.5rem',fontSize:'1.6rem',fontWeight:'600'}}>Incorporation of <br/>Public Company</span>
  <span style={{position:'absolute',margin:'-6rem 28rem',fontSize:'1.6rem',fontWeight:'600'}}>Incorporationo of<br/>Private Company</span>
  <span style={{position:'absolute',margin:'-6.4rem 52rem',fontSize:'1.6rem',fontWeight:'600'}}>Incorporationo of Nidhi Company</span>
  <span style={{position:'absolute',margin:'-6rem 78rem',fontSize:'1.6rem',fontWeight:'600'}}>Incorporation<br/>of Producer</span>
  
  <div className='service-provider'></div>
  <div style={{ position: "absolute",
  margin: "-3.4rem 30rem",
  fontSize: "2.2rem",
  fontWeight: "600",
  color: "teal",}}>All Popular Service Provider</div>
  

  <div  style={{
    margin: "2.5rem 40rem",
    fontSize: "2.8rem",
    fontWeight: "600",
    opacity: "0.5",
  }}>Consultancy</div>
  
  <div   style={{
    position: "absolute",
    margin: "-2rem 22rem",
    height: "0.1rem",
    width: "50rem",
    backgroundColor: "black",
    opacity: "0.5",
  }}></div>
  </div>
  
  )
}
